// extracted by mini-css-extract-plugin
export var alertIcon = "_se-0";